module.exports = "/_next/static/images/8ec09d7060da73bc7bc5bdf5ab646015-holding-card-vertical@0.5x.png.webp";